import { getChildrenForSource } from '../reducers/sources';

export default function(store, action) {
  const { dispatch } = store;
  const { source } = action;

  dispatch(getChildrenForSource(source));
}
